/**
 * 区分 yearFormat（numbering_rules.year_format）
 * 出典：要件書 5.2（値は 02 D-091。日本語は実装メモで決定）
 */
export const YEAR_FORMAT_VALUES = ['none', 'yyyy', 'yy'] as const;

export type YearFormat = (typeof YEAR_FORMAT_VALUES)[number];

export const YEAR_FORMAT_LABELS: Readonly<Record<YearFormat, string>> = {
  none: 'なし',
  yyyy: '西暦 4 桁',
  yy: '西暦 2 桁',
};
